import { z } from "zod";

export const getPlanSchema = z.object({
	planId: z.uuid(),
});

export type GetPlanSchema = z.infer<typeof getPlanSchema>;
